var render = function () {
  var _obj, _obj$1, _obj$2
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "switch-position" },
        [
          _c(
            "el-radio-group",
            {
              attrs: { size: "mini" },
              on: { change: _vm.openMobileLayout },
              model: {
                value: _vm.mobileLayoutInitStatus,
                callback: function ($$v) {
                  _vm.mobileLayoutInitStatus = $$v
                },
                expression: "mobileLayoutInitStatus",
              },
            },
            [
              _c("el-radio-button", { attrs: { label: false } }, [
                _c("span", {
                  staticClass:
                    "icon iconfont icon-icon_pc_outlined icon16_only",
                }),
              ]),
              _c("el-radio-button", { attrs: { label: true } }, [
                _c("span", {
                  staticClass:
                    "icon iconfont icon-icon_phone_outlined icon16_only",
                }),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.editControlButton,
              expression: "editControlButton",
            },
          ],
          staticClass: "toolbar",
        },
        [
          _c(
            "span",
            { staticStyle: { float: "right" } },
            [
              _vm.mobileLayoutStatus
                ? _c(
                    "el-button",
                    { attrs: { size: "mini" }, on: { click: _vm.editReset } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("commons.reset")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.editSave },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("commons.confirm")) +
                      "\n      "
                  ),
                ]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.editCancel } },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("commons.cancel")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.editControlButton,
              expression: "!editControlButton",
            },
          ],
          staticClass: "toolbar",
        },
        [
          _c(
            "div",
            { staticClass: "panel-info-area" },
            [
              _c("svg-icon", {
                staticClass: "toolbar-icon-active icon20 margin-left20",
                attrs: { "icon-class": "icon_left_outlined" },
                on: { click: _vm.closePanelEdit },
              }),
              _c("span", { staticClass: "text16 margin-left12" }, [
                _vm._v("\n        " + _vm._s(_vm.panelInfo.name) + "\n      "),
              ]),
            ],
            1
          ),
          _c(
            "el-tooltip",
            { attrs: { content: _vm.$t("panel.undo") } },
            [
              _c("svg-icon", {
                staticClass: "toolbar-icon-active icon16 margin-right20",
                attrs: { "icon-class": "icon_undo_outlined" },
                on: { click: _vm.undo },
              }),
            ],
            1
          ),
          _c(
            "el-tooltip",
            { attrs: { content: _vm.$t("panel.redo") } },
            [
              _c("svg-icon", {
                staticClass: "toolbar-icon-active icon16 margin-right20",
                attrs: { "icon-class": "icon_redo_outlined" },
                on: { click: _vm.redo },
              }),
            ],
            1
          ),
          !_vm.isOtherPlatform
            ? _c(
                "el-tooltip",
                { attrs: { content: _vm.$t("panel.fullscreen_preview") } },
                [
                  _c("svg-icon", {
                    staticClass: "toolbar-icon-active icon16",
                    attrs: { "icon-class": "icon_magnify_outlined" },
                    on: { click: _vm.clickPreview },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("el-divider", {
            staticStyle: { "margin-left": "20px" },
            attrs: { direction: "vertical" },
          }),
          _c(
            "span",
            { staticClass: "button_self" },
            [
              _c(
                "el-dropdown",
                {
                  attrs: {
                    "hide-on-click": false,
                    trigger: "click",
                    placement: "bottom-start",
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "icon iconfont icon-icon-more insert margin-right20",
                    },
                    [
                      _c("span", { staticClass: "icon-font-margin" }, [
                        _vm._v(_vm._s(_vm.$t("panel.more"))),
                      ]),
                    ]
                  ),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        [
                          _c(
                            "el-dropdown",
                            { attrs: { placement: "right-start" } },
                            [
                              _c(
                                "span",
                                [
                                  _c("span", {
                                    staticClass:
                                      "icon iconfont icon-icon_moments-categories_outlined icon16",
                                  }),
                                  _c(
                                    "span",
                                    { staticClass: "text14 margin-left8" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "panel.new_element_distribution"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("svg-icon", {
                                    staticClass: "icon16 margin-left8",
                                    attrs: {
                                      "icon-class": "icon_right_outlined",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.auxiliaryMatrixChange(
                                            false
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("span", { staticClass: "text14" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("panel.suspension")) +
                                            " "
                                        ),
                                      ]),
                                      !_vm.canvasStyleData.auxiliaryMatrix
                                        ? _c("i", {
                                            staticClass:
                                              " font-active el-icon-check margin-left52",
                                          })
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.auxiliaryMatrixChange(true)
                                        },
                                      },
                                    },
                                    [
                                      _c("span", { staticClass: "text14" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("panel.matrix")) +
                                            " "
                                        ),
                                      ]),
                                      _vm.canvasStyleData.auxiliaryMatrix
                                        ? _c("i", {
                                            staticClass:
                                              " font-active el-icon-check margin-left52",
                                          })
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-dropdown-item",
                        [
                          _c("span", {
                            staticClass:
                              "icon iconfont icon-icon_dialpad_outlined icon16",
                          }),
                          _c("span", { staticClass: "text14 margin-left8" }, [
                            _vm._v(_vm._s(_vm.$t("panel.aided_grid"))),
                          ]),
                          _c("el-switch", {
                            class: [
                              ((_obj = {}),
                              (_obj["grid-active"] = _vm.showGridSwitch),
                              _obj),
                              "margin-left8",
                            ],
                            attrs: { size: "mini" },
                            on: { change: _vm.showGridChange },
                            model: {
                              value: _vm.showGridSwitch,
                              callback: function ($$v) {
                                _vm.showGridSwitch = $$v
                              },
                              expression: "showGridSwitch",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-dropdown-item",
                        {
                          nativeOn: {
                            click: function ($event) {
                              return _vm.openOuterParamsSet($event)
                            },
                          },
                        },
                        [
                          _c("span", {
                            staticClass:
                              "icon iconfont icon-icon-quicksetting icon16",
                          }),
                          _c("span", { staticClass: "text14 margin-left8" }, [
                            _vm._v(_vm._s(_vm.$t("panel.params_setting"))),
                          ]),
                        ]
                      ),
                      _c(
                        "el-dropdown-item",
                        {
                          nativeOn: {
                            click: function ($event) {
                              return _vm.clearCanvas($event)
                            },
                          },
                        },
                        [
                          _c("span", {
                            staticClass:
                              "icon iconfont icon-icon_clear_outlined icon16",
                          }),
                          _c("span", { staticClass: "text14 margin-left8" }, [
                            _vm._v(_vm._s(_vm.$t("panel.clean_canvas"))),
                          ]),
                        ]
                      ),
                      _vm.showWatermarkSetting
                        ? _c(
                            "el-dropdown-item",
                            [
                              _c("span", {
                                staticClass:
                                  "icon iconfont icon-WATERMARK icon16",
                              }),
                              _c(
                                "span",
                                { staticClass: "text14 margin-left8" },
                                [_vm._v(_vm._s(_vm.$t("panel.watermark")))]
                              ),
                              _c("el-switch", {
                                class: [
                                  ((_obj$1 = {}),
                                  (_obj$1["grid-active"] =
                                    _vm.panelInfo.watermarkOpen),
                                  _obj$1),
                                  "margin-left8",
                                ],
                                attrs: { size: "mini" },
                                on: { change: _vm.styleChange },
                                model: {
                                  value: _vm.panelInfo.watermarkOpen,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.panelInfo,
                                      "watermarkOpen",
                                      $$v
                                    )
                                  },
                                  expression: "panelInfo.watermarkOpen",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showPdfPageButton
                        ? _c(
                            "el-dropdown-item",
                            [
                              _c(
                                "span",
                                [
                                  _c("svg-icon", {
                                    staticStyle: {
                                      width: "16px",
                                      height: "16px",
                                    },
                                    attrs: { "icon-class": "page-line" },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    content: _vm.$t(
                                      "panel.export_pdf_page_remark"
                                    ),
                                    placement: "top-start",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "text14 margin-left8" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("panel.export_pdf_page"))
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c("el-switch", {
                                class: [
                                  ((_obj$2 = {}),
                                  (_obj$2["grid-active"] = _vm.showPageLine),
                                  _obj$2),
                                  "margin-left8",
                                ],
                                attrs: { size: "mini" },
                                on: { change: _vm.showPageLineChange },
                                model: {
                                  value: _vm.showPageLine,
                                  callback: function ($$v) {
                                    _vm.showPageLine = $$v
                                  },
                                  expression: "showPageLine",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass:
                "icon iconfont icon-icon_effects_outlined insert margin-right20",
              on: { click: _vm.showPanel },
            },
            [
              _c("span", { staticClass: "icon-font-margin" }, [
                _vm._v(_vm._s(_vm.$t("panel.panel_style"))),
              ]),
            ]
          ),
          _c(
            "span",
            {
              staticClass:
                "icon iconfont icon-icon_Batch_outlined insert margin-right20",
              on: { click: _vm.batchOption },
            },
            [
              _c("span", { staticClass: "icon-font-margin" }, [
                _vm._v(_vm._s(_vm.$t("panel.batch_opt"))),
              ]),
            ]
          ),
          _c(
            "span",
            { staticStyle: { float: "right", "margin-right": "24px" } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    type: "primary",
                    disabled: _vm.saveButtonDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.save(false)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("commons.save")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-css",
          attrs: {
            visible: _vm.closePanelVisible,
            title: _vm.$t("panel.panel_save_tips"),
            "show-close": false,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.closePanelVisible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { staticStyle: { height: "20px" } },
            [
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("svg-icon", {
                    staticStyle: {
                      width: "20px",
                      height: "20px",
                      float: "right",
                    },
                    attrs: { "icon-class": "warn-tree" },
                  }),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 20 } }, [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "13px",
                      "margin-left": "10px",
                      "font-weight": "bold",
                      "line-height": "20px",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("panel.panel_save_warn_tips")))]
                ),
              ]),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { float: "left" },
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.closeNotSave()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("panel.do_not_save")) + "\n      ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.closePanelVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("panel.cancel")) + "\n      ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.save(true)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("panel.save")) + "\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }